import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { WCScenario } from 'app/model/Device';
import { LocalizationContext, useLocalizedStrings } from 'app/localization/Context';
import RadioButton from 'app/home/general-components/RadioButton/RadioButton';

import { ReactComponent as IconDevicesWcFanNoChange } from 'images/device/status-icon/wc-fan-no-change.svg';
import { ReactComponent as IconDevicesWcFanOff } from 'images/device/status-icon/wc-fan-off.svg';
import { ReactComponent as IconDevicesWcFanOn } from 'images/device/status-icon/wc-fan-on.svg';
import { ReactComponent as IconDevicesWcLampNoChange } from 'images/device/status-icon/wc-lamp-no-change.svg';
import { ReactComponent as IconDevicesWcLampOff } from 'images/device/status-icon/wc-lamp-off.svg';
import { ReactComponent as IconDevicesWcLampOn } from 'images/device/status-icon/wc-lamp-on.svg';
import { ReactComponent as IconDevicesWcMusicNoChange } from 'images/device/status-icon/wc-music-no-change.svg';
import { ReactComponent as IconDevicesWcMusicOff } from 'images/device/status-icon/wc-music-off.svg';
import { ReactComponent as IconDevicesWcMusicOn } from 'images/device/status-icon/wc-music-on.svg';
import { ReactComponent as IconDevicesWcSprayNoChange } from 'images/device/status-icon/wc-spray-no-change.svg';
import { ReactComponent as IconDevicesWcSprayOff } from 'images/device/status-icon/wc-spray-off.svg';
import { ReactComponent as IconDevicesWcSprayOn } from 'images/device/status-icon/wc-spray-on.svg';

// import { ReactComponent as IconDevicesWcScenarioInUseDark } from 'images/device/status-icon/wc-scenario-in-use-dark.svg';
// import { ReactComponent as IconDevicesWcScenarioInUseDarker } from 'images/device/status-icon/wc-scenario-in-use-darker.svg';
// import { ReactComponent as IconDevicesWcScenarioInUse } from 'images/device/status-icon/wc-scenario-in-use.svg';
import { ReactComponent as IconDevicesWcScenarioRefreshDark } from 'images/device/status-icon/wc-scenario-refresh-dark.svg';
import { ReactComponent as IconDevicesWcScenarioRefreshDarker } from 'images/device/status-icon/wc-scenario-refresh-darker.svg';
import { ReactComponent as IconDevicesWcScenarioRefreshOff } from 'images/device/status-icon/wc-scenario-refresh-off.svg';
// import { ReactComponent as IconThreeDotsLoadingDark } from 'images/general/three-dots-loading-dark.svg';

import { ReactComponent as IconDevicesStatusNoChange } from 'images/device/status-text-icon/no-change.svg';
import { ReactComponent as IconStatusON } from 'images/device/status-text-icon/on.svg';

import { ReactComponent as IconDevicesStatusNoChangeFa } from 'images/device/status-text-icon/no-change-fa.svg';
import { ReactComponent as IconStatusONFa } from 'images/device/status-text-icon/on-fa.svg';

import { ReactComponent as IconDevicesStatusNoChangeAr } from 'images/device/status-text-icon/no-change-ar.svg';
import { ReactComponent as IconStatusONAr } from 'images/device/status-text-icon/on-ar.svg';

import { ReactComponent as IconThreeDotsLoadingGray } from 'images/general/three-dots-loading-gray.svg';
import { ReactComponent as IconThreeDotsLoadingGradient } from 'images/general/three-dots-loading-gradient.svg';

import './All.scss'


export function WCButton({
    on, buttonOrder, onClickH, showStates,
    waitingForChangeState, canStateBeNoChange }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    let deviceIcon = IconDevicesWcLampOff;
    let label = null;

    if (canStateBeNoChange && (on === undefined)) {
        switch (buttonOrder) {
            case 1:
                deviceIcon = IconDevicesWcLampNoChange;
                break;
            case 2:
                deviceIcon = IconDevicesWcFanNoChange;
                break;
            case 3:
                deviceIcon = IconDevicesWcSprayNoChange;
                break;
            case 4:
                deviceIcon = IconDevicesWcMusicNoChange;
                break;
            default:
                break;
        }

        if (l.language === 'en') {
            label = <IconDevicesStatusNoChange className="status-text-or-icon" />;
        } else if (l.language === 'fa') {
            label = <IconDevicesStatusNoChangeFa className="status-text-or-icon" />;
        } else if (l.language === 'ar') {
            label = <IconDevicesStatusNoChangeAr className="status-text-or-icon" />;
        }
    } else if (on || !showStates) {
        if (l.language === 'en') {
            label = <IconStatusON className="status-text-or-icon" />;
        } else if (l.language === 'fa') {
            label = <IconStatusONFa className="status-text-or-icon" />;
        } else if (l.language === 'ar') {
            label = <IconStatusONAr className="status-text-or-icon" />;
        }

        switch (buttonOrder) {
            case 1:
                deviceIcon = IconDevicesWcLampOn;
                break;
            case 2:
                deviceIcon = IconDevicesWcFanOn;
                break;
            case 3:
                deviceIcon = IconDevicesWcSprayOn;
                break;
            case 4:
                deviceIcon = IconDevicesWcMusicOn;
                break;
            default:
                break;
        }
    } else {
        label = (
            <div className="device-off-label status-text-or-icon">{s.off}</div>
        )

        switch (buttonOrder) {
            case 1:
                deviceIcon = IconDevicesWcLampOff;
                break;
            case 2:
                deviceIcon = IconDevicesWcFanOff;
                break;
            case 3:
                deviceIcon = IconDevicesWcSprayOff;
                break;
            case 4:
                deviceIcon = IconDevicesWcMusicOff;
                break;
            default:
                break;
        }
    }

    const shouldShowWaiting = waitingForChangeState && !waitingForChangeState.ignoreWaiting;
    if (shouldShowWaiting) {
        if (on) {
            label = <IconThreeDotsLoadingGradient className="dots-icon" />;
        } else {
            label = <IconThreeDotsLoadingGray className="dots-icon" />;
        }
    }

    if (!showStates) {
        return (
            <div className="device-button">
                {React.createElement(deviceIcon, { className: "device-button-icon-on" })}
                <div className="status-placeholder" />
            </div>
        );
    } else {
        return (
            <div className="device-button"
                style={{ width: 54 }}>
                {/* set width > خاموش, for better placement of buttons and not changing on state changes*/}
                {/* set width to 70, for better display of texts */}
                {React.createElement(deviceIcon, {
                    className: (on === false ? "device-button-icon-off" : "device-button-icon-on")
                })}
                {label}
                <div className="device-on-click-overlay" onClick={onClickH} />
            </div>
        );
    }
}

function Button({
    on, buttonOrder, onClickHandler, darkerBorder,
    waitingForChangeState, customOpacity,
}) {
    let c = WCButton;
    return (
        <div
            className={"border " + (darkerBorder ? "darker" : "lighter")}
            style={{ opacity: customOpacity }}>
            {React.createElement(c, {
                on, buttonOrder, canStateBeNoChange: true,
                onClickH: onClickHandler, showStates: true, waitingForChangeState
            })}
        </div>
    )
}


export default function WCControl({ device, darkerBorder }) {
    const s = useLocalizedStrings();

    const onBoolClickH = useCallback((key) => {
        return (event) => {
            event.preventDefault();
            let changeStateObject = {}
            changeStateObject[key] = !device[key]
            device.changeState(changeStateObject);
        }
    }, [device]);

    const containerClass = device.active ?
        "device-detail-control with-flex active" : "device-detail-control with-flex inactive";

    return (
        <Fragment>
            <div className={containerClass}>
                <Button on={device.lamp} buttonOrder={1}
                    onClickHandler={onBoolClickH("lamp")}
                    darkerBorder={darkerBorder}
                    waitingForChangeState={device.waitingForChangeState["lamp"]} />
                <Button on={device.fan} buttonOrder={2}
                    onClickHandler={onBoolClickH("fan")}
                    darkerBorder={darkerBorder}
                    waitingForChangeState={device.waitingForChangeState["fan"]} />
                <Button on={device.spray} buttonOrder={3}
                    onClickHandler={onBoolClickH("spray")}
                    darkerBorder={darkerBorder}
                    waitingForChangeState={device.waitingForChangeState["spray"]} />
                <Button on={device.music} buttonOrder={4}
                    onClickHandler={onBoolClickH("music")}
                    darkerBorder={darkerBorder}
                    waitingForChangeState={device.waitingForChangeState["music"]} />

                <div className="wc-control-box">
                    {/* <WCScenarioSingleButton forScenario={WCScenario.in_use} s={s}
                        onClickH={() => { device.changeState({ scenario: WCScenario.in_use }) }} /> */}
                    <WCScenarioSingleButton forScenario={WCScenario.refresh} s={s}
                        onClickH={() => { device.changeState({ scenario: WCScenario.refresh }) }} />

                    <WCScenarioStatePanel
                        scenario={device.scenario} s={s}
                        onClickH={() => { device.changeState({ scenario: WCScenario.nothing }) }}
                        waitingForChangeState={device.waitingForChangeState["scenario"]} />
                </div>
            </div>
        </Fragment>

    )
}

function onButtonClickWithDontChange(setter) {
    setter(x => {
        switch (x) {
            case false:
                return true;
            case true:
                return undefined;
            case undefined:
                return false;
            default:
                return true;
        }
    });
}

export function WCScenarioSpecialSlection({ light, setData }) {
    const s = useLocalizedStrings();
    const sc = s.createScenarioProcess;

    const [intrestedStateScenario, setIntrestedStateScenario] = useState(WCScenario.nothing);
    const [intrestedStateLamp, setIntrestedStateLamp] = useState(false);
    const [intrestedStateFan, setIntrestedStateFan] = useState(false);
    const [intrestedStateSpray, setIntrestedStateSpray] = useState(false);
    const [intrestedStateMusic, setIntrestedStateMusic] = useState(false);

    useEffect(() => {
        if (intrestedStateScenario === WCScenario.nothing) {
            setData({
                "lamp": intrestedStateLamp,
                "fan": intrestedStateFan,
                "spray": intrestedStateSpray,
                "music": intrestedStateMusic,
            });
        } else {
            setData({ "scenario": intrestedStateScenario });
        }
    }, [intrestedStateScenario, intrestedStateLamp, intrestedStateFan, intrestedStateSpray, intrestedStateMusic, setData]);

    // const inUseSectionRef = React.createRef();
    const refreshSectionRef = React.createRef();
    const stateSectionRef = React.createRef();

    return (
        <div className={"wc-scenario-special-selection" + (light ? " light" : "")}>
            {/* <div className={"basic-row" + ((intrestedStateScenario !== WCScenario.in_use) ? " inactive" : "")} ref={inUseSectionRef} >
                <RadioButton light={light} isOn={intrestedStateScenario === WCScenario.in_use}
                    setOn={() => { setIntrestedStateScenario(WCScenario.in_use) }}
                    additionalRef={inUseSectionRef} />
                {light ? null : <IconDevicesWcScenarioInUseDarker className="icon" />}
                <div className="title">{sc.inUse}</div>
            </div> */}
            <div className={"basic-row" + ((intrestedStateScenario !== WCScenario.refresh) ? " inactive" : "")} ref={refreshSectionRef}>
                <RadioButton light={light} isOn={intrestedStateScenario === WCScenario.refresh}
                    setOn={() => { setIntrestedStateScenario(WCScenario.refresh) }}
                    additionalRef={refreshSectionRef} />
                {light ? null : <IconDevicesWcScenarioRefreshDarker className="icon" />}
                <div className="title">{sc.refresh}</div>
            </div>
            <div className={"wc-state-row" + ((intrestedStateScenario !== WCScenario.nothing) ? " inactive" : "")} ref={stateSectionRef}>
                <RadioButton light={light} isOn={intrestedStateScenario === WCScenario.nothing}
                    setOn={() => { setIntrestedStateScenario(WCScenario.nothing) }}
                    additionalRef={stateSectionRef} />
                <div className="title">{sc.setThisStateImmediately}</div>

                <div className="wc-state device-detail-control active">
                    <Button on={intrestedStateLamp} buttonOrder={1}
                        onClickHandler={() => { onButtonClickWithDontChange(setIntrestedStateLamp) }}
                        darkerBorder={true} />
                    <Button on={intrestedStateFan} buttonOrder={2}
                        onClickHandler={() => { onButtonClickWithDontChange(setIntrestedStateFan) }}
                        darkerBorder={true} />
                    <Button on={intrestedStateSpray} buttonOrder={3}
                        onClickHandler={() => { onButtonClickWithDontChange(setIntrestedStateSpray) }}
                        darkerBorder={true} />
                    <Button on={intrestedStateMusic} buttonOrder={4}
                        onClickHandler={() => { onButtonClickWithDontChange(setIntrestedStateMusic) }}
                        darkerBorder={true} />
                </div>
            </div>
        </div>
    );
}

export function WCScenarioTag({ l, s, device }) {
    if (!device.active) {
        // وقتی که قطع هست توی لیست دستگاه‌ها نشون ندیم
        // چون این پنل باید روی اسم دستگاه باشه
        // اسم هم باید روی صفحه دیسکانکت باشه
        // ولی خود این باید زیر صفحه دیسکانکت باشه
        return null;
    }
    // if ((device.scenario !== WCScenario.in_use) && (device.scenario !== WCScenario.refresh)) {
    if (device.scenario !== WCScenario.refresh) {
        return null;
    }

    let icon, text;
    // if (device.scenario === WCScenario.in_use) {
    //     text = s.wc.inUse;
    //     icon = IconDevicesWcScenarioInUseDark;
    // } else {
    text = s.wc.refreshing;
    icon = IconDevicesWcScenarioRefreshDark;
    // }

    return (
        <div className="wc-scenario-tag"
            dir={l.isRTL ? "rtl" : "ltr"}
            lang={l.language}
            onClick={() => { device.changeState({ scenario: WCScenario.nothing }) }}>
            <div className="label">{text}</div>
            {React.createElement(icon, { className: "icon" })}
        </div>
    )
}

function WCScenarioSingleButton({ onClickH, forScenario, s }) {
    let deviceIcon, labelText;
    // if (forScenario === WCScenario.in_use) {
    //     deviceIcon = IconDevicesWcScenarioInUse;
    //     labelText = s.wc.inUse;
    // } else 
    if (forScenario === WCScenario.refresh) {
        deviceIcon = IconDevicesWcScenarioRefreshOff;
        labelText = s.wc.refresh;
    }

    return (
        <div className="device-button"
            style={{ width: 65 }}> {/* set width > label's length, for better placement of buttons and not changing on state changes*/}
            {/* {React.createElement(deviceIcon, { className: "device-button-icon--on" })} */}
            {/* <div className="device-curtain-state-label status-text-or-icon">{labelText}</div> */}
            {React.createElement(deviceIcon, { className: "device-button-icon-off" })}
            <div className="device-off-label status-text-or-icon">{labelText}</div>
            <div className="device-on-click-overlay" onClick={onClickH} />
        </div>
    );
}

function WCScenarioStatePanel({ onClickH, scenario, waitingForChangeState, s }) {
    // if ((scenario !== WCScenario.in_use) && (scenario !== WCScenario.refresh)) {
    if (scenario !== WCScenario.refresh) {
        return null;
    }

    let deviceIcon, labelText;
    // if (scenario === WCScenario.in_use) {
    //     deviceIcon = IconDevicesWcScenarioInUseDark;
    //     labelText = s.wc.inUse;
    // } else 
    if (scenario === WCScenario.refresh) {
        deviceIcon = IconDevicesWcScenarioRefreshDark;
        labelText = s.wc.refreshing;
    }

    // const shouldShowWaiting = waitingForChangeState && !waitingForChangeState.ignoreWaiting;

    return (
        // <div className={"wc-panel full"} onClick={shouldShowWaiting ? undefined : onClickH}>
        <div className={"wc-panel full"} onClick={onClickH}>
            {React.createElement(deviceIcon, { className: "icon" })}
            <div className="label">{labelText}</div>

            {/* {
                !shouldShowWaiting ?
                    null
                    // <div className="info">{s.curtain.tapToStop}</div>
                    : <IconThreeDotsLoadingDark className="curtain-dots-icon" />
            } */}
        </div>
    );
}